













import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import BrandInfoForm from '@superUI/Forms/BrandInfoForm'
import RequestButton from '@components/RequestButton'

settings =
  name: "BrandInfoCreate"
  components: {
    Back,
    SuperContainerView,
    BrandInfoForm,
    RequestButton,
  }

  resources:
    newBrandInfo:
      resourceName: 'brand_info'
      slug: 'brand_infos/new'

  vue:
    methods:
      hiSave: -> 
        @saveItem('prime.newBrandInfo')
      onSave: (item) -> @$router.push({ name: 'BrandInfoShowPage', params: { brandInfoId: item.id } })

export default VueOptions.vue settings
